<template>
  <v-card
    class="border-none rounded-lg px-3 shadow-sm"
    :class="[mission ? 'card-mission-reward' : 'card-reward']"
    no-body
  >
    <div class="rounded-lg p-3 overflow-hidden contant-reward">
      <div class="text-center">
        <template v-if="getRewardList[count].random_reward_item_type != 1">
          <b class="f-xl" data-lang="win_reward">{{ $t("win_reward") }}</b>
          <div class="text-gray mt-2">
            <small>
              <template v-if="!mission"
                >{{ getRewardList[count].redeem_code }} :</template
              >
              <span class="text-success">
                <font-awesome-icon
                  icon="check-circle"
                  class="mx-1 text-success"
                />
                <span data-lang="received_prize">
                  {{ $t("received_prize") }}
                </span>
              </span>
            </small>
          </div>
        </template>
        <template v-else>
          <b class="f-xl" data-lang="not_received_prize">{{
            $t("not_received_prize")
          }}</b>
          <br />
          <div class="text-gray mt-2">
            <small>
              <template v-if="!mission"
                >{{ getRewardList[count].redeem_code }} :</template
              >
              <span class="text-danger">
                <font-awesome-icon
                  icon="check-circle"
                  class="mx-1 text-danger"
                />
                <span data-lang="not_received_prize">{{
                  $t("not_received_prize")
                }}</span>
              </span>
            </small>
          </div>
        </template>
      </div>
      <div class="reward-image mb-3">
        <c-img
          :src="rewardImage(getRewardList[count])"
          @error="handleImageSrc"
          class="image-reward"
        ></c-img>
      </div>
      <p
        class="text-center mt-3 f-md"
        id="previewMessage"
        v-if="getRewardList[count].random_reward_item_type != 1"
      >
        {{
          getRewardList[count].random_reward_item_type == 4
            ? `คุณได้รับ ${getRewardList[count].point} Point
          คะแนนสะสมของคุณปัจจุบัน
          ${
            point_total
              ? point_total.toLocaleString()
              : (
                  $store.state.shortProfile.total_point +
                  getRewardList[count].point
                ).toLocaleString()
          } Point`
            : getRewardList[count].item_name
        }}
      </p>
      <p class="text-center mt-3 f-md" id="previewMessage" v-else>
        {{
          `เสียใจด้วยนะ คุณ ${$store.state.shortProfile.first_name_th} ${$store.state.shortProfile.last_name_th} ไม่ได้รับของรางวัลไว้โอกาสหน้า`
        }}
      </p>
      <div class="text-center">
        <c-btn
          v-if="countList.length - (count + 1) != 0"
          pill
          variant="confirm-primary"
          class="shadow-box mb-2 mt-0 btn-open-box"
          @click="$emit('nextBox')"
          data-test="step4-next-box-btn"
        >
          {{ `เปิดกล่องต่อไป ${this.count + 1}/${this.countList.length}` }}
        </c-btn>
        <template v-else>
          <c-btn
            v-if="mission && countList.length == 1"
            pill
            variant="confirm-primary"
            class="shadow-box mb-2 mt-0 btn-open-box"
            @click="goToMission"
            data-test="step4-mission-btn"
          >
            <font-awesome-icon icon="gifts" class="mx-2" />
            <span
              :data-lang="
                mission ? 'back_mission_prize' : 'back_random_reward_prize'
              "
            >
              {{
                mission
                  ? $t("back_mission_prize")
                  : $t("back_random_reward_prize")
              }}
            </span>
          </c-btn>
          <c-btn
            v-else-if="countList.length == 1"
            pill
            variant="confirm-primary"
            class="shadow-box mb-2 mt-0 btn-open-box"
            @click="$router.push('/reward-transaction')"
            data-test="step4-reward-btn"
          >
            <font-awesome-icon icon="gifts" class="mx-2" />
            <span
              :data-lang="
                mission ? 'back_mission_prize' : 'back_random_reward_prize'
              "
            >
              {{
                mission
                  ? $t("back_mission_prize")
                  : $t("back_random_reward_prize")
              }}
            </span>
          </c-btn>
          <c-btn
            v-else
            pill
            variant="confirm-primary"
            class="shadow-box mb-2 mt-0 btn-open-box"
            @click="$emit('lastBox')"
            data-test="step4-last-box-btn"
          >
            {{ $t("next_page") }}
          </c-btn>
        </template>
        <div
          class="text-gray cursor-pointer"
          v-if="countList.length - (count + 1) != 0"
          @click="$emit('openAll')"
          data-test="step4-open-all-box-btn"
        >
          <small>
            <u data-lang="open_all_box"
              >{{ $t("open_all_box") }} ({{
                countList.length - (count + 1)
              }})</u
            ></small
          >
        </div>
        <div v-else style="height: 24px"></div>
        <div
          class="footer-panel"
          v-if="
            !mission &&
            countList.length - (count + 1) == 0 &&
            countList.length == 1
          "
        >
          <div>
            <c-btn
              variant="confirm-primary"
              icon
              class="shadow-box btn-circle"
              @click="$emit('resend')"
              data-test="step4-resend-btn"
            >
              <div class="qr-code-scan p-0 m-0">
                <font-awesome-icon icon="qrcode" class="f-lg" />
              </div>
            </c-btn>

            <div class="text-center f-sm" data-lang="send_more_code">
              {{ $t("send_more_code") }}
            </div>
          </div>
          <div>
            <c-btn
              variant="confirm-primary"
              icon
              class="shadow-box btn-circle"
              @click="$router.push('/profile')"
              data-test="step4-home-btn"
            >
              <font-awesome-icon icon="home" class="f-xl" />
            </c-btn>
            <div class="text-center f-sm" data-lang="back">
              {{ $t("back") }}
            </div>
          </div>
        </div>
      </div>
    </div>
  </v-card>
</template>

<script>
export default {
  props: {
    countList: { required: true },
    getRewardList: { required: true },
    count: { required: true },
    point_total: { required: true },
    mission: {
      required: false,
      default: false,
      type: Boolean
    }
  },
  data() {
    return {
      profile: {
        point: 0
      }
    };
  },
  computed: {},

  methods: {
    rewardImage(items) {
      if (items) {
        if (items.random_reward_item_type == 4)
          return require("@/assets/images/point.png");
        if (items.random_reward_item_type == 1)
          return require("@/assets/images/Fail.png");
        if (items.item_img) return items.item_img;
        return require("@/assets/images/default-image.png");
      }
      return require("@/assets/images/default-image.png");
    },
    async getPoint() {
      const profile = await this.$store.dispatch("getUserProfile");
      this.profile = profile;
    },
    goToMission() {
      this.$emit("goToMission");
    }
  }
};
</script>
